import ResourceService from '@/services/ResourceService'

import { filterGroups } from '../data/resourceFilters'

export default {
  namespaced: true,

  state: {
    isFetching: false,
    resources: [],
    limit: 10,
    page: 1,
    total: 0,
    searchString: '',
    filterGroups: filterGroups
  },

  getters: {
    totalPages (state) {
      return Math.ceil(state.total / state.limit)
    }
  },

  mutations: {
    set (state, resources) {
      state.resources = resources
    },

    setIsFetching (state, isFetching) {
      state.isFetching = isFetching
    },

    setLimit (state, limit) {
      state.limit = limit
    },

    setPage (state, page) {
      state.page = page
    },

    setTotal (state, total) {
      state.total = total
    },

    setSearchString (state, searchString) {
      state.searchString = searchString
    },

    resetFilters (state) {
      // Deep clone the array so it doesn't keep the previous values
      // https://stackoverflow.com/a/9886013/2999215
      state.filterGroups = JSON.parse(JSON.stringify(filterGroups))
    },

    setFilter (state, { filterGroup, filterId, checked = true }) {
      const group = state.filterGroups.find(group => group.key === filterGroup)
      const filter = group.filters.find(filter => filter.id === filterId)
      if (group && filter) {
        filter.checked = checked
      }
    }
  },

  actions: {
    fetch ({ commit, state }, filters = {}) {
      // Add page and limit as url params
      Object.assign(filters, {
        page: state.page,
        limit: state.limit
      })

      /**
       * Check all the filter groups. If any of them have at least one filter checked,
       * add them to a simple object that will be passed to the GET request. If a group
       * doesn't have any filter checked or has all checked, don't include them in the
       * object so the query is cleaner.
       */
      // let queryObject = {}
      for (let filterGroup of state.filterGroups) {
        const selected = filterGroup.filters.filter(filter => filter.checked)
        if (selected.length > 0 && selected.length < filterGroup.filters.length) {
          filters[filterGroup.key] = selected.map(filter => filter.id)
        }
      }

      // If search string is provided, add it as url param too
      if (state.searchString !== '') {
        Object.assign(filters, { search: state.searchString })
      }

      commit('setIsFetching', true)

      return ResourceService.getAll(filters)
        .then(({ resources, pagination }) => {
          if (pagination.total !== state.total) {
            commit('setTotal', pagination.total)
          }
          if (pagination.per_page !== state.limit) {
            commit('setLimit', pagination.per_page)
          }
          if (pagination.current_page !== state.page) {
            commit('setPage', pagination.current_page)
          }
          commit('set', resources)
          commit('setIsFetching', false)
          return resources
        })
    },

    setSearchString ({ commit }, searchString) {
      commit('setSearchString', searchString)
    },

    setPage ({ commit, state, getters }, page) {
      if (page >= 1 && page <= getters.totalPages) {
        commit('setPage', page)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/resources.js